import { render, staticRenderFns } from "./ReceiveComplete.vue?vue&type=template&id=6b0ad6ca&"
import script from "./ReceiveComplete.vue?vue&type=script&lang=js&"
export * from "./ReceiveComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports